export default __webpack_public_path__ + "static/bundle_offers_storycard-5d4614e4c22b5203745530a130889380.png";